module.exports = __webpack_public_path__ + "img/Egypt.5af0cace.png";